import type {UpdateUserManagementProfileFormPayload} from "./update-user-management-profile.schema";
import {updateUserManagementProfile} from "@project/sdk/user-management";
import {UpdateUserManagementProfileResponse} from "@project/sdk/user-management/zod";
import {mutationOptions} from "@tanstack/react-query";
import {
  userManagementUserKeys,
  userManagementUserMutationKeys,
} from "../../../userManagementUser-keys";

export function updateUserManagementProfileMutationOptions(userId: string) {
  return mutationOptions({
    mutationKey: userManagementUserMutationKeys.updateUserManagementProfile,
    mutationFn: async (payload: UpdateUserManagementProfileFormPayload) =>
      UpdateUserManagementProfileResponse.parse(await updateUserManagementProfile(userId, payload)),
    onSuccess: async (_data, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: userManagementUserKeys.detail(userId)}),
        client.invalidateQueries({queryKey: userManagementUserKeys.lists()}),
      ]);
    },
  });
}
